import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { CHARACTER_LEVELS } from '@dndModels/Constants';

interface Props {
  char: Character;
  char_int?: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterPBCustomizations({ 
  char,
  char_int,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [override_pb, setOverridePB] = useState(char.customizations.overrides.pb);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row" className="padded">
      <FlexBox xs_expand={0} className="centered" style={{ width: "33%" }} direction="column">
        <FlexBox xs_expand={0} className="header">
          Override PB: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { char.proficiency_modifier }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox 
          name="Choose a PB"
          value={ override_pb === undefined ? "Don't Override" : `${override_pb}` } 
          options={["Don't Override",...CHARACTER_LEVELS]}
          disabled={ disabled }
          onChange={ async (changed: string) => {
            if (changed === "Don't Override") {
              delete char.customizations.overrides.pb;
              setOverridePB(undefined);
            } else {
              const pb = +changed;
              char.customizations.overrides.pb = pb;
              setOverridePB(pb);
            }
            char.changed();
            char.subscription_holder.recalculate();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
